import styled from 'styled-components';
import { List } from 'react-bootstrap-icons';
import { COLORS, BREAKPOINTS, SPACING, TRANSITIONS } from '../../style';

export const Row = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${SPACING.md};
  background: ${COLORS.blue};
  color: ${COLORS.white};
  width: 100%;
  height: 20vh;
  position: fixed;
  z-index: 10;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding: ${SPACING.sm} ${SPACING.md};
    height: auto;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: ${SPACING.sm};
  }
`;

export const LogoTitle = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 40px;
    margin-right: ${SPACING.sm};
  }

  h1 {
    font-size: 24px;
    font-weight: 700;
    color: ${COLORS.white};
    margin: 0;

    @media (max-width: ${BREAKPOINTS.mobile}) {
      font-size: 18px;
    }
  }
`;

export const DesktopNav = styled.nav`
  display: flex;
  align-items: center;

  ul {
    display: flex;

    li {
      margin: 0 ${SPACING.xs};

      a {
        color: ${COLORS.white};

        &:hover {
          color: ${COLORS.grey};
        }
      }
    }
  }

  > a {
    margin-left: ${SPACING.md};
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const Hamburguer = styled(List)`
  display: none;
  cursor: pointer;
  font-size: 24px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: flex;
  }
`;

export const MobileNav = styled.nav<{ $open: boolean }>`
  display: none;
  position: fixed;
  left: ${({ $open }) => ($open ? '0' : '-100%')};
  top: 0;
  z-index: 9;
  width: 70%;
  height: 100vh;
  padding: ${SPACING.lg} ${SPACING.md};
  background: ${COLORS.blue};
  transition: left ${TRANSITIONS.slow} ease;

  li {
    margin: ${SPACING.sm} 0;

    a {
      color: ${COLORS.white};

      &:hover {
        color: ${COLORS.grey};
      }
    }
  }

  > a {
    margin-top: ${SPACING.md};
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: block;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: ${SPACING.lg} ${SPACING.sm};
  }
`;

export const BackgroundExit = styled.div<{ $open: boolean }>`
  display: none;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 8;
  width: 100%;
  height: 100%;
  background: rgba(1, 1, 1, 0.7);

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: ${({ $open }) => ($open ? 'block' : 'none')};
  }
`;